// extracted by mini-css-extract-plugin
export default {"modalButtons":"pqBEU232VhrmP6Y_9xtW","submit":"GZqzj_LZ052cIIWky75t","titleContainer":"nqpRyDVz_jN5tznQIHpH","dossierOverview":"rRH9oyCka2UWtt6ZQUBQ"};